import axios from 'axios';

const API_URL = '/api/auth';

class AuthService {
  login(username, password, twoFactorCode = '') {
    return axios.post(`${API_URL}/login`, { username, password, twoFactorCode })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
          this.setupAxiosInterceptors();
        }
        return response.data;
      });
  }

  register(username, password) {
    return axios.post(`${API_URL}/register`, { username, password })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data));
          this.setupAxiosInterceptors();
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  setupAxiosInterceptors() {
    const user = this.getCurrentUser();
    if (user && user.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
    }

    // Add response interceptor for token expiry
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          this.logout();
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }
}

export default new AuthService();
